var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.buttonContainerCss},[_c('b-button',{attrs:{"type":"submit"},on:{"click":_vm.ProcessBooking}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }